import { Company } from "api/schema/companies/companySchema";
import React, {
  Dispatch,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from "react";

export interface CompaniesContextType {
  activeCompany?: Company | null;
  setActiveCompany: Dispatch<SetStateAction<Company | null>>;
}

export const CompaniesContext = createContext<CompaniesContextType>(
  {} as CompaniesContextType
);

export const CompaniesContextProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [activeCompany, setActiveCompany] = useState<Company | null>(null);

  return (
    <CompaniesContext.Provider value={{ activeCompany, setActiveCompany }}>
      {children}
    </CompaniesContext.Provider>
  );
};

export const useCompanies = () => useContext(CompaniesContext);
